import { DamoAuthComponent } from '@damotech/damoauth-lib';
import { Component } from '@angular/core';

@Component({
  selector: 'damoauth-web',
  standalone: true,
  imports: [DamoAuthComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent { 
}
